import type { ChessBoard, ChessColor } from '../../types/chess';
import { findKing } from './core';
import { getValidMoves } from './moves';

export function isInCheck(board: ChessBoard, color: ChessColor): boolean {
  const kingPos = findKing(board, color);
  if (!kingPos) return false;

  const opponentColor = color === 'white' ? 'black' : 'white';
  
  for (let row = 0; row < 8; row++) {
    for (let col = 0; col < 8; col++) {
      const piece = board[row][col];
      if (piece?.color === opponentColor) {
        const moves = getValidMoves({ board, position: { row, col }, skipCheckValidation: true });
        if (moves.some(move => move.row === kingPos.row && move.col === kingPos.col)) {
          return true;
        }
      }
    }
  }
  return false;
}

export function isCheckmate(board: ChessBoard, color: ChessColor): boolean {
  if (!isInCheck(board, color)) return false;

  for (let row = 0; row < 8; row++) {
    for (let col = 0; col < 8; col++) {
      const piece = board[row][col];
      if (piece?.color === color) {
        const moves = getValidMoves({ board, position: { row, col } });
        if (moves.length > 0) return false;
      }
    }
  }
  return true;
}

export function isStalemate(board: ChessBoard, color: ChessColor): boolean {
  if (isInCheck(board, color)) return false;

  for (let row = 0; row < 8; row++) {
    for (let col = 0; col < 8; col++) {
      const piece = board[row][col];
      if (piece?.color === color) {
        const moves = getValidMoves({ board, position: { row, col } });
        if (moves.length > 0) return false;
      }
    }
  }
  return true;
}